<ui-confirmation-dialog
    #emptyModal
    size="small"
    header="import.mappingTableSectionColumn.emptyModalHeader"
    primaryButtonLabel="import.mappingTableSectionColumn.emptyModalPrimaryButton"
    secondaryButtonLabel="cancel"
>
    <p>{{ 'import.mappingTableSectionColumn.noDataInThisColumn' | translate }}</p>
    <p>{{ 'import.mappingTableSectionColumn.matchConfirmationQuestion' | translate }}</p>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    #replacementModal
    size="small"
    header="import.mappingTableSectionColumn.replacementModalHeader"
    primaryButtonLabel="import.mappingTableSectionColumn.replacementModalPrimaryButton"
    secondaryButtonLabel="cancel"
>
    <p>
        {{
            'import.mappingTableSectionColumn.replacementModalDescription'
                | translate
                    : {
                          columnName: selectionColumn?.name ?? '',
                          previousHumiMappingLabel: previousHumiMapping?.translatableLabel
                              ? (previousHumiMapping.translatableLabel | translate)
                              : previousHumiMapping?.label,
                          sectionColumnLabel: sectionColumn?.translatableLabel
                              ? (sectionColumn.translatableLabel | translate)
                              : sectionColumn?.label,
                      }
        }}
    </p>
</ui-confirmation-dialog>

<div class="app-grid margin-bottom-2">
    <div class="columns-5">
        <div class="mapping-column">
            <div>
                @if (sectionColumn.translatableLabel) {
                    {{ sectionColumn.translatableLabel | translate }}
                } @else {
                    {{ sectionColumn.label }}
                }
                <ng-container *ngIf="sectionColumn.required || sectionColumn.conditionallyRequired">*</ng-container>
            </div>
            <mat-icon svgIcon="chevronRight"></mat-icon>
        </div>
    </div>
    <div class="columns-4">
        <div class="mapping-column">
            <mat-form-field
                class="no-labels no-helpers"
                [class.mat-form-field-invalid]="
                    (sectionColumn.required || sectionColumn.conditionallyRequired) && !sectionColumn.csvColumn
                "
            >
                <mat-select
                    [required]="sectionColumn.required || sectionColumn.conditionallyRequired"
                    #csvColumnOption="ngModel"
                    (valueChange)="onColumnSelection($event, csvColumnOption.control)"
                    [ngModel]="sectionColumn.csvColumn"
                    placeholder="{{ 'import.mappingTableSectionColumn.doNotImport' | translate }}"
                    [name]="'column-select-' + sectionColumn.label | kebabcase"
                    [attr.name]="'column-select-' + sectionColumn.label | kebabcase"
                >
                    <mat-option [value]="null">{{
                        'import.mappingTableSectionColumn.doNotImport' | translate
                    }}</mat-option>
                    <mat-option *ngFor="let csvColumn of importerService.columns" [value]="csvColumn">{{
                        csvColumn.name
                    }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="columns-3">
        <div class="mapping-column">
            <div
                class="preview-column"
                [class.noValue]="!csvColumnOption.value || csvColumnOption.value?.getDisplayValues() === 'Empty column'"
            >
                {{ csvColumnOption.value?.getDisplayValues(3) || '-' }}
            </div>
        </div>
    </div>
</div>
